/**
 * These are constant values based on model attributes of
 * Item Location Model (ks-pg-model)
 */
export const PURCHASE_COST = 'dt:line_unit_cost:purchase_cost';
export const AVERAGE_COST = 'dt:line_unit_cost:average_cost';
